import { render, staticRenderFns } from "./IconBookOpenSolid.vue?vue&type=template&id=9da7ee2c"
import script from "./IconBookOpenSolid.vue?vue&type=script&lang=js"
export * from "./IconBookOpenSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports